module.exports = __webpack_public_path__ + "static/media/invenimus.d8d53481.png";